export default function IconImage({ src }) {
  return <img src={src} className="w-full"></img>;
}
